import { jsx as _jsx } from "react/jsx-runtime";
import { CUITag, CUITagLabel } from '../CUITag/CUITag';

const CUIHomepageComingSoonTag = (_ref) => {
  let rest = Object.assign({}, _ref);
  return /*#__PURE__*/_jsx(CUITag, Object.assign({
    color: "GREYSCALE.MOON",
    backgroundColor: "GREYSCALE.GALAXY"
  }, rest, {
    children: /*#__PURE__*/_jsx(CUITagLabel, {
      children: "Coming Soon"
    })
  }));
};

export default CUIHomepageComingSoonTag;